import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.625 16.444H19l-1.23-1.248a1.82 1.82 0 0 1-.52-1.277V11.11c0-2.322-1.46-4.298-3.5-5.03v-.303C13.75 4.796 12.966 4 12 4s-1.75.796-1.75 1.778v.303c-2.04.732-3.5 2.708-3.5 5.03v2.808c0 .479-.187.938-.52 1.277L5 16.444h4.375m5.25 0v.89C14.625 18.805 13.45 20 12 20s-2.625-1.194-2.625-2.667v-.889m5.25 0h-5.25",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };